import React, { useState } from "react";

function MultiSelectDropdown({ options = [], selectedValues = [], onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  // Ensure we compare IDs as Numbers to prevent selection bugs
  const isSelected = (id) => selectedValues.map(v => Number(v)).includes(Number(id));

  const toggle = (id) => {
    const numericId = Number(id);
    let updated;
    if (isSelected(numericId)) {
      updated = selectedValues.filter(v => Number(v) !== numericId);
    } else {
      updated = [...selectedValues, numericId];
    }
    onChange(updated);
  };

  const removeItem = (id) => {
    onChange(selectedValues.filter(v => Number(v) !== Number(id)));
  };

  const getLabel = (id) => {
    for (let cat of options) {
      const found = cat.subs?.find(s => Number(s.id) === Number(id));
      if (found) return found.name;
    }
    return "Unknown";
  };

  return (
    <div className="position-relative w-100">
      <div
        className="form-control d-flex flex-wrap align-items-center bg-white"
        style={{ minHeight: "45px", cursor: "pointer", gap: "8px" }}
        onClick={() => setOpen(!open)}
      >
        {selectedValues.length === 0 && <span className="text-muted">Search or Select Specialities...</span>}

        {selectedValues.map(id => (
          <span key={id} className="badge bg-light text-dark border d-flex align-items-center py-2 px-2" style={{ fontSize: "12px" }}>
            {getLabel(id)}
            <span
              onClick={(e) => { e.stopPropagation(); removeItem(id); }}
              className="ms-2 text-danger fw-bold"
              style={{ cursor: "pointer", fontSize: "16px", lineHeight: "1" }}
            >
              ×
            </span>
          </span>
        ))}
      </div>

      {open && (
        <div
          className="border bg-white p-2 mt-1 shadow-lg"
          style={{ position: "absolute", width: "100%", zIndex: 1050, maxHeight: "300px", overflowY: "auto", borderRadius: "8px" }}
        >
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Filter sub-specialities..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />

          {options.map(cat => {
            const filteredSubs = cat.subs?.filter(sub =>
              sub.name.toLowerCase().includes(search.toLowerCase())
            ) || [];

            if (filteredSubs.length === 0) return null;

            return (
              <div key={cat.id} className="mb-3">
                <div className="text-muted small fw-bold text-uppercase px-2 mb-1" style={{ letterSpacing: '0.5px' }}>
                  {cat.name}
                </div>

                {filteredSubs.map(sub => (
                  <div 
                    key={sub.id} 
                    className="d-flex align-items-center p-2 rounded hover-effect" 
                    style={{ cursor: "pointer" }}
                    onClick={() => toggle(sub.id)}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input me-2 mt-0"
                      checked={isSelected(sub.id)}
                      readOnly
                    />
                    <span style={{ fontSize: "14px" }}>{sub.name}</span>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      )}
      {/* Click outside to close (optional simple implementation) */}
      {open && <div style={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, zIndex: 1040 }} onClick={() => setOpen(false)} />}
    </div>
  );
}

export default MultiSelectDropdown;